<div id="tables">

    <h2>Tablas de la lección</h2>

    <div id="heading-tables-empty" class="mt-3" *ngIf="!hasTables">
        <p>No hay tablas en esta lección.</p>
    </div>

    <div id="heading-tables-table-div" class="mt-3" *ngIf="hasTables">
        <table id="heading-tables-table" class="mt-3">
            <thead>
                <tr>
                    <th>Ver</th>
                    <!-- <th>Copiar HTML</th> -->
                    <!-- <th>Eliminar</th> -->
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let table of tables">
                    <td>
                        <iframe [src]="table.safeUrl" width="300" height="300" frameborder="1"></iframe>
                        <p>
                            <a href="{{ table.url }}" target="_blank">
                                <i class="fas fa-eye"></i>
                                <span>Ver en una nueva pestaña</span>
                            </a>
                        </p>
                    </td>
                    <!--
                    <td>
                        <a href="#" title="Copiar referencia" class="ms-3" (click)="copyTableHtml(table, $event)">
                            <i class="far fa-copy"></i>
                            <span>Copiar</span>
                        </a>
                        <span class="ms-3 d-none">
                            <i class="far fa-thumbs-up"></i>
                            <span>¡Copiado!</span>
                        </span>
                    </td>
                    -->
                    <!--
                    <td>
                        <a href="#" title="Eliminar elemento" class="red"
                            (click)="deleteTable(table.id, table.lesson)">
                            <i class="fas fa-times"></i>
                            <span>Eliminar</span>
                        </a>
                    </td>
                    -->
                </tr>
            </tbody>
        </table>
    </div>
</div>